import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import Subnav, { SubnavProps } from "./subnav"

export const query = graphql`
  fragment TopNavigationFields on DatoCmsTopNavigation {
    items {
      id
      url
      heading
      links {
        id
        url
        title
      }
    }
    hamburger {
      id
      url
      heading
      links {
        id
        url
        title
      }
    }
  }
`

const Topnav = ({
  pathName,
  items,
}: {
  pathName?: string
  items: Queries.TopNavigationFieldsFragment["items"]
}) => {
  if (!items) {
    return null
  }

  let subnavItems: SubnavProps["items"] = []
  if (pathName) {
    const firstPath = pathName.split("/")[1]
    const menuItem = items.find(
      item => item?.url.replace(/\//g, "") === firstPath.replace(/\//g, ""),
    )
    subnavItems = menuItem?.links.slice()
  }

  return (
    <nav id="menu-topnav" className="c-topnav o-wrapper">
      <div className="c-topnav__main">
        {items.map(item => {
          if (item && item.id && item.url) {
            return (
              <Link
                key={item.id}
                to={item.url}
                className="c-topnav__item"
                activeClassName="active"
                partiallyActive={item.url !== "/"}
              >
                {item?.heading}
              </Link>
            )
          } else {
            return null
          }
        })}
      </div>
      {subnavItems && subnavItems.length > 0 && <Subnav items={subnavItems} />}
    </nav>
  )
}

export default Topnav
